import convertDate from './convertDate'
import convertTime from './convertTime'

export default {
	convertDate,
	convertTime,
}
